<template>
    <div class="data_score">
        <div class="data_score_detail" v-for="(item, index) in options" :key="index">
            <van-rate class="data_score_detail_icon" :size="30" readonly gutter='6px' :value="item.answer/2" allow-half color="#19cca0" void-icon="star" void-color="#eee" />
            <div class="data_score_detail_text">
                <div class="data_score_detail_num">{{item.answer_cnt}}人</div>
                <div class="data_score_detail_ratio">{{(item.answer_cnt/done_cnt*100).toFixed(1)}}%</div>
            </div>
        </div>
        <div class="data_score_text">
            <div class="title">{{index + 1}}. {{title}}</div>
            <van-image
              width="100%"
              height="100%"
              v-if="img_url !== ''"
              :src="img_url"
            />
        </div>
    </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    question_id: {
      type: Number
    },
    options: {
      type: Array
    },
    done_cnt: {
      type: Number
    },
    index: {
      type: Number
    },
    img_url: {
      type: String
    }
  }
}
</script>

<style lang='scss' scoped>
.data_score{
    width: 91.47%;
    margin: 10px auto;
    background-color: #fff;
    border-radius: 12px;
    padding: 10px 0;
    .data_score_detail{
        display: flex;
        justify-content: space-between;
        width: 91.47%;
        margin: 5px auto;
        height: 30px;
        box-sizing: border-box;
        .data_score_detail_icon {
            height: 30px;
        }
        .data_score_detail_text{
          width: 120px;
          height: 30px;
          line-height: 30px;
          text-align: end;
          display: flex;
          justify-content: space-between;
          .data_score_detail_ratio{
            width: 40%;
          }
          .data_score_detail_num{
            width: 60%;
            text-align: center;
          }
        }
    }
    .data_score_text{
        width: 91.47%;
        margin: 10px auto;
        font-weight: 500;
        margin-bottom: 5px;
    }
}
</style>
